import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { UnitSelect } from "../../Components/UnitSelect"
import { BlockField, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { DeleteButton } from "../../Components/DeleteButton"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipDataItem } from "../../Components/ShipDataItem"
import { IShipDataAnchor } from "../../Types"
import { predefined } from "./Context"

interface ShipDataAnchorViewProps {
  data: IShipDataAnchor;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeAnchor: () => void;
}

export function ShipDataAnchorView({ data, editable, index, onEdited, removeAnchor }: ShipDataAnchorViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `anchors[${index}].`;

  const predefinedPlaces = ["", "bow", "stern", "variable"];

  // Initialize anchorType with the value from data, or undefined if not present
  const [anchorType, setAnchorType] = useState<string | undefined>(data.anchorType);

  const selectAnchorType = useCallback((value?: string) => {
    setAnchorType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipDataItem namePrefix={namePrefix} id={data.id}>
      <BlockRow className="block-row-1">
        <BlockField label={t("anchor_type")} className="block_field_small_16">
          <PredefinedSelect value={anchorType} predefined={predefined.anchorType} label={(v) => t(`anchor_${v}`)} customValue={t("other")} name={`${namePrefix}anchorType`} onSelect={selectAnchorType} readOnly={!editable} sort />
        </BlockField>
        <BlockField label={t("anchor_weight")} className="block_field_small_8">
          <BlockFieldInputs>
            <input className="unit"name={`${namePrefix}weight`} defaultValue={data.weight} onChange={onEdited} readOnly={!editable} />
            <UnitSelect kind="weight" name={`${namePrefix}weightUnit`} value={data.weightUnit} editable={editable} onChange={onEdited} omit={["tons"]} />
          </BlockFieldInputs>
        </BlockField>

        <BlockField label={t("anchor_location")} className="block_field_small_10">
          <select className="ShipTypeSelect" name={`${namePrefix}placeInstallation`} defaultValue={data.placeInstallation} onChange={onEdited}>
            {predefinedPlaces.map((type) => (
              <option value={type} key={type}>{t(`${type}`)}</option>
            ))}
          </select>
        </BlockField>
        <BlockField label={t("anchor_chain")}>
          <input name={`${namePrefix}chain`} defaultValue={data.chain} onChange={onEdited} readOnly={!editable} />
        </BlockField>

      </BlockRow>

      <BlockRow className="block-row-last">
        <BlockField label={t("anchor_chain_lead")} className="block_field_small_16">
          <input name={`${namePrefix}chainLead`} defaultValue={data.chainLead} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("anchor_windlass")} className="block_field_small_10">
          <input name={`${namePrefix}windlass`} defaultValue={data.windlass} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("anchor_windless_drive")} className="block_field_small_12">
          <input name={`${namePrefix}windlassDrive`} defaultValue={data.windlassDrive} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <BlockField label={t("anchor_windless_manfacturer")}>
          <input name={`${namePrefix}windlassManufacturer`} defaultValue={data.windlassManufacturer} onChange={onEdited} readOnly={!editable} />
        </BlockField>
        <DeleteButton onClick={removeAnchor} />
      </BlockRow>
    </ShipDataItem>
  );
}
